import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import PracticeAreas from './components/PracticeAreas';
import HowItWorks from './components/HowItWorks';
import Differentials from './components/Differentials';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="font-sans">
      <Header />
      <main>
        <Hero />
        <About />
        <PracticeAreas />
        <HowItWorks />
        <Differentials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
